<template>

    <b-modal :id="id" :footer-border-variant="'white'" :header-border-variant="'white'" centered :hide-header="true"
        :ref="id" :hide-footer="true" class="DialogModal font-roboto" :no-close-on-backdrop="DisableClickOutSideToClose"
        v-model="modalShow" :no-fade="noFade">
        <b-overlay :show="isLoading">
            <div class="font-roboto DialogPadding">
                <slot></slot>
                <div class="BottomBtnGroup">
                    <button v-if="!isOkayOnly && !NoDefaultBtn" class="btn btn-primary" type="button" @click="$emit('callBackConfirm')"
                     :Disabled="isConfirmDisabled">
                        <slot name="Confirm"> {{!ConfirmText ? 'Confirm' :ConfirmText}}</slot>
                    </button>
                    <button v-if="!isOkayOnly && !NoDefaultBtn" class="btn btn-light" type="button" @click="ToggleModal()">
                        <slot name="Cancel"> {{ !CancelText ?'Cancel':CancelText }}</slot>
                    </button>
                    <button v-if="isOkayOnly && !NoDefaultBtn" class="btn btn-primary" type="button" @click="ToggleModal()">
                        <slot name="OK">{{!ConfirmText ? 'ok' :ConfirmText}}</slot>
                    </button>
                    <slot name="ExtraBtn"></slot>
                </div>
            </div>
        </b-overlay>
    </b-modal>

</template>


<script>

export default {
    props: ['id', 'isOkayOnly', 'NoDefaultBtn', 'DisableClickOutSideToClose', 'noFade', 'isConfirmDisabled','ConfirmText','CancelText'],
    data() {
        return {
            isLoading : false,
            modalShow : false,
        }
    },
    methods: {
        ToggleModal() {
            this.modalShow = !this.modalShow;
        },
        CloseModal(){
            
            this.modalShow = false;
        },
        ShowModal(){
            
            this.modalShow= true;
        }
    }
}
</script>

<style lang="scss">

.DialogPadding{
    padding:32px;
}

.modal-dialog .modal-body {
    padding: 0px;
}

.Modal-MainTitle {
    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    /* 27px */
    letter-spacing: -0.198px;
}

.Modal-TitleDesc{
    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
    /* Text/Paragraph 2 */
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    letter-spacing: 0.15px;
}

.Modal-SubTitle {
    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    /* 21px */
    letter-spacing: -0.154px;
}

.Main-Text {
    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 21px */
    letter-spacing: 0.15px;
}

.Sub-Text {
    color: var(--on-surface-60, rgba(0, 0, 0, 0.60));
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 18px */
    letter-spacing: 0.15px;
}

.BottomBtnGroup {
    display: flex;
    gap: 16px;
    justify-content: end
}

/* Delete/Confirm 弹框底部按钮：尺寸回到“原来版本”（跟随 .btn），Cancel 与 Confirm 尺寸一致，只样式不同 */
.DialogModal .BottomBtnGroup .btn {
    padding: 0.375rem 1.75rem !important;
    line-height: 1.5 !important;
    border-radius: 0.25rem !important;
    font-size: 14px !important;
    font-family: Inter, sans-serif !important;
    font-weight: 700 !important;
    box-shadow: none !important;
    text-decoration: none !important;
}

/* Cancel（btn-light）：保持原 btn-light 的颜色体系，只去掉可能的装饰并补 hover 灰底一致性 */
.DialogModal .BottomBtnGroup .btn-light:hover:not(:disabled):not(.disabled),
.DialogModal .BottomBtnGroup .btn-light:focus:not(:disabled):not(.disabled),
.DialogModal .BottomBtnGroup .btn-light:active:not(:disabled):not(.disabled) {
    background: rgba(0, 18, 26, 0.05) !important;
    box-shadow: none !important;
}

.LayeredLabel {
    display: flex;
    flex-direction: column;

    &:before {
        display: none !important;
    }
}

.DotLoading:after {
  content: ' .';
  animation: dots 1s steps(5, end) infinite;}

  @keyframes dots {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  40% {
    color: black;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  60% {
    text-shadow:
      .25em 0 0 black,
      .5em 0 0 rgba(0,0,0,0);}
  80%, 100% {
    text-shadow:
      .25em 0 0 black,
      .5em 0 0 black;}}

</style>
